import React from 'react';
import { Target, Flame, Activity, Zap, Users, Clock } from 'lucide-react';
export function ClassDemo() {
  return <section className="py-16 md:py-24 px-4 bg-surface/30 border-y border-zinc-800/50 overflow-hidden" data-id="element-57">
      <div className="max-w-5xl mx-auto" data-id="element-58">
        <div className="text-center mb-12 md:mb-16" data-id="element-59">
          <h2 className="text-3xl md:text-5xl font-extrabold mb-6 tracking-tight" data-id="element-60">
            Mirá una clase real <span className="text-primary" data-id="element-61">por dentro</span>
          </h2>
          <p className="text-lg md:text-xl text-zinc-400 max-w-2xl mx-auto" data-id="element-62">
            Esto no es un PDF más. Es una página real del sistema: estructura
            clara, tiempos definidos y variantes listas para aplicar.
          </p>
        </div>

        {/* Product page card */}
        <div className="relative bg-black border border-zinc-800 rounded-3xl shadow-2xl overflow-hidden" data-id="element-63">
          {/* Window chrome to feel like a real product page */}
          <div className="flex items-center justify-between gap-3 px-5 md:px-7 py-3 border-b border-zinc-800 bg-surface/60" data-id="element-64">
            <div className="flex items-center gap-1.5" data-id="element-65">
              <span className="w-3 h-3 rounded-full bg-zinc-700" data-id="element-66" />
              <span className="w-3 h-3 rounded-full bg-zinc-700" data-id="element-67" />
              <span className="w-3 h-3 rounded-full bg-zinc-700" data-id="element-68" />
            </div>
            <div className="text-[11px] md:text-xs font-bold text-zinc-500 uppercase tracking-wider" data-id="element-69">
              HIIT Pro · Tomo 2 · Página 14 de 52
            </div>
            <div className="w-10" data-id="element-70" />
          </div>

          <div className="p-6 md:p-10" data-id="element-71">
            {/* Header */}
            <div className="flex items-center justify-between border-b border-zinc-800 pb-6 mb-8" data-id="element-72">
              <div data-id="element-73">
                <div className="text-primary font-bold text-sm uppercase tracking-wider mb-1" data-id="element-74">
                  Semana 14 • Día 2
                </div>
                <h3 className="text-2xl md:text-3xl font-extrabold text-white" data-id="element-75">
                  Resistencia Metabólica
                </h3>
              </div>
              <div className="hidden sm:flex items-center gap-2 bg-zinc-900 px-4 py-2 rounded-full" data-id="element-76">
                <Clock className="w-4 h-4 text-primary" data-id="element-77" />
                <span className="text-sm font-bold text-zinc-300" data-id="element-78">
                  45 Minutos
                </span>
              </div>
            </div>

            <div className="grid md:grid-cols-2 gap-8 md:gap-12" data-id="element-79">
              {/* Left Column */}
              <div className="space-y-8" data-id="element-80">
                <div data-id="element-81">
                  <div className="flex items-center gap-3 mb-3" data-id="element-82">
                    <div className="w-8 h-8 rounded-full bg-primary/10 flex items-center justify-center" data-id="element-83">
                      <Target className="w-4 h-4 text-primary" data-id="element-84" />
                    </div>
                    <h4 className="text-lg font-bold text-white" data-id="element-85">
                      Objetivo Semanal
                    </h4>
                  </div>
                  <p className="text-zinc-400 pl-11" data-id="element-86">
                    Aumentar la capacidad aeróbica mediante intervalos de
                    trabajo sostenido con pausas incompletas.
                  </p>
                </div>

                <div data-id="element-87">
                  <div className="flex items-center gap-3 mb-3" data-id="element-88">
                    <div className="w-8 h-8 rounded-full bg-primary/10 flex items-center justify-center" data-id="element-89">
                      <Activity className="w-4 h-4 text-primary" data-id="element-90" />
                    </div>
                    <h4 className="text-lg font-bold text-white" data-id="element-91">
                      Calentamiento (8 min)
                    </h4>
                  </div>
                  <ul className="text-zinc-400 pl-11 space-y-2 list-disc list-inside marker:text-zinc-700" data-id="element-92">
                    <li data-id="element-93">Movilidad articular dinámica (3 min)</li>
                    <li data-id="element-94">Activación de core: Planchas dinámicas 3x30s</li>
                    <li data-id="element-95">Elevación de pulso: Jumping jacks + High knees</li>
                  </ul>
                </div>

                <div data-id="element-96">
                  <div className="flex items-center gap-3 mb-3" data-id="element-97">
                    <div className="w-8 h-8 rounded-full bg-primary/10 flex items-center justify-center" data-id="element-98">
                      <Flame className="w-4 h-4 text-primary" data-id="element-99" />
                    </div>
                    <h4 className="text-lg font-bold text-white" data-id="element-100">
                      Bloque Principal (25 min)
                    </h4>
                  </div>
                  <div className="pl-11" data-id="element-101">
                    <div className="bg-zinc-900 border border-zinc-800 rounded-xl p-4 mb-3" data-id="element-102">
                      <div className="text-primary font-bold text-sm mb-2" data-id="element-103">
                        AMRAP 12 Minutos
                      </div>
                      <ul className="text-zinc-300 space-y-1 text-sm" data-id="element-104">
                        <li data-id="element-105">• 15x Kettlebell Swings</li>
                        <li data-id="element-106">• 10x Burpees over object</li>
                        <li data-id="element-107">• 20x Mountain Climbers</li>
                      </ul>
                    </div>
                    <p className="text-sm text-zinc-500 italic" data-id="element-108">
                      Pausa 2 minutos y repetir bloque con intensidad aumentada.
                    </p>
                  </div>
                </div>
              </div>

              {/* Right Column */}
              <div className="space-y-8" data-id="element-109">
                <div data-id="element-110">
                  <div className="flex items-center gap-3 mb-3" data-id="element-111">
                    <div className="w-8 h-8 rounded-full bg-primary/10 flex items-center justify-center" data-id="element-112">
                      <Zap className="w-4 h-4 text-primary" data-id="element-113" />
                    </div>
                    <h4 className="text-lg font-bold text-white" data-id="element-114">
                      Finisher (7 min)
                    </h4>
                  </div>
                  <div className="pl-11" data-id="element-115">
                    <div className="bg-primary/5 border border-primary/20 rounded-xl p-4" data-id="element-116">
                      <div className="text-primary font-bold text-sm mb-2" data-id="element-117">
                        Tabata Extremo (20s ON / 10s OFF)
                      </div>
                      <p className="text-zinc-300 text-sm" data-id="element-118">
                        Alternar entre: Squat Jumps y Push-ups explosivas. 8
                        rondas totales.
                      </p>
                    </div>
                  </div>
                </div>

                <div data-id="element-119">
                  <div className="flex items-center gap-3 mb-3" data-id="element-120">
                    <div className="w-8 h-8 rounded-full bg-primary/10 flex items-center justify-center" data-id="element-121">
                      <Users className="w-4 h-4 text-primary" data-id="element-122" />
                    </div>
                    <h4 className="text-lg font-bold text-white" data-id="element-123">
                      Variantes por Nivel
                    </h4>
                  </div>
                  <div className="pl-11 space-y-3" data-id="element-124">
                    <div className="flex items-start gap-2" data-id="element-125">
                      <span className="bg-zinc-800 text-zinc-300 text-xs font-bold px-2 py-1 rounded mt-0.5" data-id="element-126">
                        Básico
                      </span>
                      <span className="text-sm text-zinc-400" data-id="element-127">
                        Burpees sin salto, Push-ups con rodillas apoyadas.
                      </span>
                    </div>
                    <div className="flex items-start gap-2" data-id="element-128">
                      <span className="bg-primary/20 text-primary text-xs font-bold px-2 py-1 rounded mt-0.5" data-id="element-129">
                        Avanzado
                      </span>
                      <span className="text-sm text-zinc-400" data-id="element-130">
                        Kettlebell más pesada, Push-ups con aplauso.
                      </span>
                    </div>
                  </div>
                </div>

                {/* Total time footer */}
                <div className="bg-zinc-900 border border-zinc-800 rounded-xl px-4 py-3 flex items-center justify-between" data-id="element-131">
                  <span className="text-sm font-bold text-zinc-400 uppercase tracking-wider" data-id="element-132">
                    Tiempo total
                  </span>
                  <span className="text-lg font-extrabold text-primary" data-id="element-133">
                    45 min
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <p className="text-center text-zinc-500 text-sm md:text-base mt-6" data-id="element-134">
          Y así son{' '}
          <span className="text-white font-bold" data-id="element-135">las 300+ clases</span>. Listas
          para abrir y dar.
        </p>
      </div>
    </section>;
}